import { Row, Col } from 'antd'
import { useDispatch, useSelector } from 'react-redux'

import { Button } from 'App/components'
import { createProcessingSelector, withdrawRequestRequest, WITHDRAW_REQUEST } from 'store'

export type TWithdrawRequestDialogProps = {
  requestId: string
  advertId: string
}

const processingRequest = createProcessingSelector([WITHDRAW_REQUEST])

export const WithdrawRequestDialog = (props: TWithdrawRequestDialogProps) => {
  const dispatch = useDispatch()
  const processing = useSelector(processingRequest)

  const handleClick = () => {
    dispatch(withdrawRequestRequest(props))
  }

  return (
    <Row gutter={[0, 28]}>
      <Col xs={24}>
        <Row justify="center">
          <span>Are you sure you want to withdraw this request?</span>
        </Row>
      </Col>
      <Col xs={24}>
        <Row justify="center">
          <Button loading={processing} onClick={handleClick}>
            Withdraw
          </Button>
        </Row>
      </Col>
    </Row>
  )
}
